import { jsx } from 'react/jsx-runtime';
import { isString } from '@fabric-app/utils/guards';
import { forwardRef } from 'react';

const defaultLoader = ({ src, width, quality }) => {
  const params = new URLSearchParams();
  if (width) params.append("w", width.toString());
  if (quality) params.append("q", quality.toString());
  return `${src}?${params.toString()}`;
};
const CompatImage = /* @__PURE__ */ forwardRef(({
  src,
  alt,
  width,
  height,
  fill,
  loader,
  quality,
  unoptimized,
  onLoadingComplete,
  placeholder,
  blurDataURL,
  // Deprecated props
  layout,
  objectFit,
  objectPosition,
  lazyBoundary,
  lazyRoot,
  ...rest
}, ref) => {
  const finalLoader = loader ?? defaultLoader;
  const imageSrc = isString(src) ? finalLoader({
    src,
    width: typeof width === "number" ? width : parseInt(width ?? "0", 10),
    quality: typeof quality === "number" ? quality : parseInt(quality ?? "0", 10)
  }) : "src" in src ? src.src : src.default.src;
  return /* @__PURE__ */ jsx("img", {
    ref,
    src: imageSrc,
    alt,
    width: fill ? void 0 : width,
    height: fill ? void 0 : height,
    style: fill ? {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit,
      objectPosition
    } : {},
    ...rest
  });
});
CompatImage.displayName = "Image";

export { CompatImage };
//# sourceMappingURL=Image.js.map
